<a style="cursor: pointer;" (click)="scanBtnClicked($event)">
    <s2a-svg-icon path="global/actions/" name="qrIcon"></s2a-svg-icon>
</a>